import { render, staticRenderFns } from "./DriversScatterChartWidget.vue?vue&type=template&id=8164881c&scoped=true&"
import script from "./DriversScatterChartWidget.vue?vue&type=script&lang=js&"
export * from "./DriversScatterChartWidget.vue?vue&type=script&lang=js&"
import style0 from "./DriversScatterChartWidget.vue?vue&type=style&index=0&id=8164881c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8164881c",
  null
  
)

export default component.exports